import { useState } from 'react'
import { Icon } from '@iconify/react'
import { Button, Dropdown, Menu, SubMenu } from '@pepper/ui'
import clsx from 'clsx'

import Topics from './Topics'
import Keywords from './Keywords'
import SeoGuideLines from './SeoGuideLines'
import PositionFilter from 'components/idea-lab/PositionFilter'
import Items from './Items'
import Sort from './Sort'

import s from './Filter.module.css'

type Props = {
  isSuggested?: boolean
}

const menu = (handleChange: () => void, isSuggested?: boolean): JSX.Element => {
  return (
    <Menu
      className={clsx(s.menu, {
        [s.menuSuggestions]: isSuggested,
      })}
    >
      <SubMenu
        title={
          isSuggested ? (
            <div className={s.title}>
              <Icon icon="lucide:arrow-left" />
              Topic contains
            </div>
          ) : (
            'Topic contains'
          )
        }
        popupClassName={s.subMenu}
      >
        <Topics onChange={handleChange} />
      </SubMenu>
      <SubMenu
        title={
          isSuggested ? (
            <div className={s.title}>
              <Icon icon="lucide:arrow-left" />
              Keyword contains
            </div>
          ) : (
            'Keyword contains'
          )
        }
        popupClassName={s.subMenu}
      >
        <Keywords onChange={handleChange} />
      </SubMenu>
      <SubMenu
        title={
          isSuggested ? (
            <div className={s.title}>
              <Icon icon="lucide:arrow-left" />
              Exclude Positions
            </div>
          ) : (
            'Exclude Positions'
          )
        }
        popupClassName={s.subMenu}
      >
        <PositionFilter />
      </SubMenu>
      {!isSuggested && (
        <SubMenu title="SEO Guidelines" popupClassName={s.subMenu}>
          <SeoGuideLines onChange={handleChange} />
        </SubMenu>
      )}
      {!isSuggested && (
        <SubMenu title="Items" popupClassName={s.subMenu}>
          <Items onChange={handleChange} />
        </SubMenu>
      )}
    </Menu>
  )
}

export const Filter = ({ isSuggested }: Props) => {
  const [isFilterVisible, setIsFilterVisible] = useState(false)
  const [isSortVisible, setIsSortVisible] = useState(false)

  const handleChange = () => {
    setIsFilterVisible(false)
  }

  return (
    <div className={s.wrapper}>
      <Dropdown
        overlay={() => menu(handleChange, isSuggested)}
        trigger={['click']}
        onVisibleChange={visible => setIsFilterVisible(visible)}
      >
        {isSuggested ? (
          <div
            role="none"
            className={clsx(s.trigger, {
              [s.active]: isFilterVisible,
            })}
          >
            <Icon icon="lucide:filter" width={16} height={16} />
          </div>
        ) : (
          <button className={s.filterTrigger}>
            Filters
            <Icon icon="lucide:chevron-down" />
          </button>
        )}
      </Dropdown>
      <Dropdown
        overlay={<Sort isSuggested={!!isSuggested} />}
        trigger={['click']}
        onVisibleChange={visible => setIsSortVisible(visible)}
      >
        {isSuggested ? (
          <div
            role="none"
            className={clsx(s.trigger, {
              [s.active]: isSortVisible,
            })}
          >
            <Icon icon="uil:sort-amount-up" width={18} height={18} />
          </div>
        ) : (
          <Button
            type="default"
            icon={<Icon icon="uil:sort-amount-up" width={18} height={18} />}
            iconPlacement="left"
          >
            Sort
          </Button>
        )}
      </Dropdown>
    </div>
  )
}
